import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import dayjs from 'dayjs';
import type { Dayjs } from 'dayjs';
import type { RootState } from '@/rootReducer';
import { EnvelopeRounded } from '@/assets/images';
import './DatePickerScheduledSendListItem.scss';

interface Props {
	date: Dayjs;
	setSelectedDate: (x: Dayjs) => void;
	selectedDate: Dayjs;
	setShowTimes: (x: boolean) => void;
	setShowDates: (x: boolean) => void;
}

const DatePickerScheduledSendListItem = ({
	date,
	setSelectedDate,
	selectedDate,
	setShowTimes,
	setShowDates
}: Props): JSX.Element => {
	const [scheduledEmailLimits, user] = useSelector(
		(state: RootState) => [
			state.email.getIn(['email', 'scheduled', 'limits']).toJS(),
			state.user.getIn(['authorize', 'user']).toJS()
		],
		shallowEqual
	);

	const dayNumber = date.format('D');
	const monthNumber = date.format('M');

	return (
		<div
			key={monthNumber + dayNumber}
			className={`scheduled-send-list-item-holder ${selectedDate.format('D') === dayNumber && selectedDate.format('M') === monthNumber ? 'selected' : ''} `}
			onClick={() => {
				setSelectedDate(date);
				setShowTimes(true);
				setShowDates(false);

				const el = document.getElementsByClassName(
					'scheduled-send-date-picker-holder'
				);

				if (el && el[0]) {
					if (
						date.format('D') === dayjs().format('D') &&
						date.format('M') === dayjs().format('M')
					) {
						el[0].scroll(0, 0);
					} else {
						el[0].scroll(0, 514);
					}
				}
			}}
		>
			<span className="scheduled-send-list-item-weekday">
				{date.format('ddd')}
			</span>
			<span className="scheduled-send-list-item-date">
				{dayjs().format('MMM D') === date.format('MMM D')
					? 'Today'
					: date.format('MMM D')}
			</span>
			<EnvelopeRounded className="scheduled-send-list-item-envelope" />
			<span className="scheduled-send-list-item-emails-left">
				{scheduledEmailLimits[date.format('MM-DD-YYYY')]?.limit ??
					user.emailLimit}{' '}
				left
			</span>
		</div>
	);
};

export default DatePickerScheduledSendListItem;
